enum ProcessorApiType {
    API = "Api",
    Manual = "Manual"
}

export default ProcessorApiType;